import { ShieldCheck } from 'lucide-react';
import React from 'react';

const TRUST_POINTS = [
  'Vendors verified with NIN + school ID',
  'Every listing tied to a real FUTO vendor',
  'Reports investigated, not ignored',
];

export const TrustStrip: React.FC = () => {
  return (
    <section className='border-y border-border bg-card'>
      <div className='container grid gap-6 py-8 sm:grid-cols-3 sm:gap-4'>
        {TRUST_POINTS.map((point) => (
          <div key={point} className='flex items-center gap-3'>
            <span className='flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary'>
              <ShieldCheck className='h-[18px] w-[18px] text-primary' />
            </span>
            <p className='text-sm font-medium text-foreground'>{point}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustStrip;
